<template>
  <div class="emissionPart">
    <div class="title_line">
      <expertTitle>排放源</expertTitle>
      <span>处于行业前<span style="margin:0 5px">5</span>位置</span>
    </div>
    <div class="partBox">
      <div class="bigBox leftBox">
        <div class="left_title">生产设备点位</div>
        <div class="left_small_box">
          <div class="box">
            <div class="square square1">
              <div class="center_num" style="color:#F4C48F">419</div>
            </div>
            <div class="square_name"><span style="color:#F4C48F">生产</span>设备点位</div>
          </div>
          <div class="box">
            <div class="square square2">
              <div class="center_num" style="color:#99F5FF">92</div>
            </div>

            <div class="square_name"><span style="color:#99F5FF">治理</span>设备点位</div>
          </div>
          <div class="box">
            <div class="square square3">
              <div class="center_num" style="color:#30D594">412</div>
            </div>
            <div class="square_name"><span style="color:#30D594">监测</span>设备点位</div>
          </div>
        </div>
      </div>
      <div class="bigBox rightBox">
        <div class="right_title">排放源关联率</div>
        
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import expertTitle from "./../../components/expertTitle";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { expertTitle },
  props: {},
  data() {
    //这里存放数据
    return {};
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.emissionPart {
  padding: 20px;
  .title_line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 20px;
      color: #e2effd;
    }
  }
  .partBox {
    display: flex;
    justify-content: space-between;
    height: calc(100% - 28px);
    padding-top: 20px;
    .bigBox {
      background: linear-gradient(
        225deg,
        rgba(108, 151, 255, 0.2) 0%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%
      );
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    }
    .leftBox {
      width: 64%;
      .left_title {
        background: linear-gradient(
          225deg,
          rgba(108, 151, 255, 0) 0%,
          rgba(84, 134, 255, 0.15) 49%,
          rgba(58, 116, 255, 0) 100%
        );
        height: 36px;
        text-align: center;
        font-size: 20px;
        color: #c1eef3;
        line-height: 36px;
      }
      .left_small_box {
        display: flex;
        justify-content: space-around;
        padding: 0 30px;
        .box {
          width: 158px;
          height: 250px;
          padding-top: 30px;
          .square {
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
            border: 1px solid;
            border-image: linear-gradient(
                180deg,
                rgba(169, 200, 251, 1),
                rgba(113, 152, 246, 0)
              )
              1 1;
            width: 100%;
            height: 161px;
            .center_num {
              text-align: center;
              line-height: 120px;
              font-size: 52px;
              font-family: "number" !important;
              font-weight: 400;
              color: #30d594;
            }
          }
          .square1 {
            background: linear-gradient(
              180deg,
              rgba(241, 123, 44, 0.27) 0%,
              rgba(247, 181, 0, 0) 100%
            );
          }
          .square2 {
            background: linear-gradient(
              180deg,
              rgba(108, 151, 255, 0.2) 0%,
              rgba(58, 116, 255, 0) 100%
            );
          }
          .square3 {
            background: linear-gradient(
              180deg,
              rgba(44, 241, 49, 0.27) 0%,
              rgba(247, 181, 0, 0) 100%
            );
          }
          .square_name {
            font-size: 20px;
            font-weight: 500;
            color: #e2effd;
            line-height: 28px;
            text-align: center;
            margin-top: 25px;
          }
        }
      }
    }
    .rightBox {
      width: 35%;
      .right_title {
        background: linear-gradient(
          225deg,
          rgba(108, 151, 255, 0) 0%,
          rgba(84, 134, 255, 0.15) 49%,
          rgba(58, 116, 255, 0) 100%
        );
        height: 36px;
        text-align: center;
        font-size: 20px;
        color: #c1eef3;
        line-height: 36px;
      }
    }
  }
}
</style>